/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RequeueEscalatedActionRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {RequeueEscalatedActionResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const requeueEscalatedAction = (request: RequeueEscalatedActionRequest, options?: CashRequestOptions) => post<RequeueEscalatedActionRequest, RequeueEscalatedActionResponse>("/2.0/cash/requeue-escalated-action", request, {...options, rejectOnError: true })